import React from "react";
import { useNavigate } from "react-router-dom";
import SpeedGraph from "./SpeedGraph";

const SpeedMetrics = () => {
  const navigate = useNavigate();
  const data = [
    { x: "2024-02-01T08:00:00", y: 90 },
    { x: "2024-02-02T08:00:00", y: 15 },
    { x: "2024-02-03T08:00:00", y: 75 },
    { x: "2024-02-04T08:00:00", y: 100 },
    { x: "2024-02-05T08:00:00", y: 65 },
    { x: "2024-02-06T08:00:00", y: 45 },
    { x: "2024-02-07T08:00:00", y: 80 },
    { x: "2024-02-09T08:00:00", y: 100 },
  ];

  return (
    <div className="flex flex-col p-5 h-full overflow-y-hidden">
      <div className="font-medium text-white flex items-center justify-between">
        <div className="flex text-xl items-center gap-2">
          <button type="button" onClick={() => navigate("/speedMetrics")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.0"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          Speed Metrics
        </div>
      </div>
      <div className="grid grid-cols-2 max-h-[85vh] pb-2 pt-4 gap-4">
        <div className="flex flex-col gap-2 h-[37vh]">
          <label className="text-sm text-white font-medium">Speed</label>
          <div className="h-full">
            <SpeedGraph data={data} index={1} />
          </div>
        </div>
        <div className="flex flex-col gap-2 h-[37vh]">
          <label className="text-sm text-white font-medium">
            Idle Speed for Fuel+Engine
          </label>
          <div className="h-full flex flex-col gap-5">
            <div className="flex h-1/2 gap-5 text-white font-semibold rounded bg-black p-5 text-xl justify-center items-center">
              <label className="text-base text-neutral-300">
                Total Hours Driving
              </label>
              <label>67 Hrs</label>
            </div>
            <div className="flex h-1/2 gap-5 text-white font-semibold rounded bg-black p-5 text-xl justify-center items-center">
              <label className="text-base text-neutral-300">
                Hours Over Speed
              </label>
              <label>20 Hrs</label>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 h-[37vh]">
          <label className="text-sm text-white font-medium">
            Driver Idle Graph
          </label>
          <div className="h-full">
            <SpeedGraph data={data} index={3} />
          </div>
        </div>
        <div className="flex flex-col gap-2 h-[37vh]">
          <label className="text-sm text-white font-medium">
            Driver Speed Alarms
          </label>
          <div className="h-full">
            <SpeedGraph data={data} index={4} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeedMetrics;
